var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteConfirmIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 45,
    viewBox: "0 0 44 45",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.0858 33.4969L27.5427 4.92474C25.0454 0.720589 18.9579 0.715003 16.4573 4.92474L0.914966 33.4969C-1.63789 37.7928 1.45285 43.2328 6.45639 43.2328H37.5431C42.5424 43.2328 45.6386 37.7972 43.0858 33.4969ZM22 38.0766C20.5788 38.0766 19.4219 36.9197 19.4219 35.4985C19.4219 34.0772 20.5788 32.9203 22 32.9203C23.4212 32.9203 24.5781 34.0772 24.5781 35.4985C24.5781 36.9197 23.4212 38.0766 22 38.0766ZM24.5781 27.7641C24.5781 29.1853 23.4212 30.3422 22 30.3422C20.5788 30.3422 19.4219 29.1853 19.4219 27.7641V14.8735C19.4219 13.4522 20.5788 12.2953 22 12.2953C23.4212 12.2953 24.5781 13.4522 24.5781 14.8735V27.7641Z",
    fill: "#F84545"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteConfirmIcon);
export default __webpack_public_path__ + "static/media/DeleteConfirmIcon.1fef4686b804d5b3fe122684896012cd.svg";
export { ForwardRef as ReactComponent };